import { signout } from './appSlice';
import { abbiWayApi } from '../services/abbiWayApi';
/**
 * Every sign-out path dispatches `signout()` (menus, Settings, forced and
 * expired-token sign-outs, account deletion). After it, reset RTK Query so
 * cached data (e.g. `getMe`) can't keep the UI looking signed in or leak to
 * the next user, and in-flight subscriptions are dropped (#403).
 */
export const signoutResetMiddleware = storeApi => next => action => {
    const result = next(action);
    if (signout.match(action)) {
        storeApi.dispatch(abbiWayApi.util.resetApiState());
    }
    return result;
};
